import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { GlossaryIndex } from "../components/glossary/GlossaryIndex";
import { glossaryIndexHead } from "../lib/glossary/head";
import { glossaryIndexPath, loadGlossary } from "../lib/glossary/index";
import { GLOSSARY_UI } from "../lib/glossary/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** The glossary hub in a non-English language, at `/<lang>/glossary`. */
export const Route = createFileRoute("/$lang/glossary/")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = glossaryIndexPath(lang);
    if (path !== `/${params.lang}/glossary`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, bundle: await loadGlossary(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? glossaryIndexHead(
          loaderData.lang,
          GLOSSARY_UI[loaderData.lang],
          loaderData.bundle,
        )
      : {},
  component: LocalizedGlossaryIndex,
});

function LocalizedGlossaryIndex() {
  const { lang, bundle } = Route.useLoaderData();
  return <GlossaryIndex lang={lang} ui={GLOSSARY_UI[lang]} bundle={bundle} />;
}
